function generateFileTypeErrorMessage(fileTypes) {
	if (!Array.isArray(fileTypes) || fileTypes.length === 0) {
		return "Invalid file types provided.";
	}
	const formattedTypes = fileTypes.map(type => type.trim()).join(', ');
	return `Invalid attachment file type. Please upload file in these formats only: ${formattedTypes}`;
}

export default generateFileTypeErrorMessage;
